module.exports = __webpack_public_path__ + "photo-8.486f87bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/building/full/photo-8.jpg
// module id = 630
// module chunks = 0